import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CustomButton from "../../../components/CustomButton";
import { FormTypes } from "../../../utils/models";
import { isMobile } from "react-device-detect";
import { push } from "redux-first-history";
import { useDispatch } from "react-redux";
import { back } from "redux-first-history/build/es6/actions";

const AboutHelpModal = ({ open, handleClose, formType }: any) => {
  const dispatch = useDispatch();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowConfirmDialog(false), 500);
  }, [open]);

  const onFAQNo = () => {
    setShowConfirmDialog(true);
  };

  const navigateToSupport = () => {
    handleClose();
    dispatch(push("/help"));
  };

  return (
    <Modal
      role="dialog"
      aria-modal
      aria-labelledby="help-modal"
      className={"modal-container"}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{
        backdrop: Backdrop,
      }}
      slotProps={{
        backdrop: {
          timeout: 500,
          sx: { zIndex: "-1" },
        },
      }}
    >
      <Fade in={open}>
        <div className={"modal-paper"}>
          <Box component="h3" m={1} className={"modal-title"}>
            {showConfirmDialog
              ? "Would you like to contact customer support?"
              : modalInfo[formType].title}
          </Box>
          {!showConfirmDialog && (
            <>
              {modalInfo[formType].subTitle.map((text: any, index: number) => (
                <p key={index} className="modal-subtitle">
                  {text}
                  {index === modalInfo[formType].subTitle.length - 1 && (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`/samples/${modalInfo[formType].sampleFile}`}
                      className={"link"}
                    >
                      {modalInfo[formType].sampleFormDescription}
                    </a>
                  )}
                </p>
              ))}
              <p className="modal-subtitle">
                Did this FAQ answer your question?
              </p>
            </>
          )}
          <Grid
            container
            className="modal-button-container"
            sx={{ mt: showConfirmDialog ? "1em" : "0" }}
          >
            <CustomButton
              variant="outlined"
              disableElevation={false}
              label={"no"}
              onClick={showConfirmDialog ? handleClose : onFAQNo}
            />
            <CustomButton
              variant="contained"
              disableElevation={true}
              label={"yes"}
              onClick={showConfirmDialog ? navigateToSupport : handleClose}
            />
          </Grid>
        </div>
      </Fade>
    </Modal>
  );
};

export default AboutHelpModal;

const modalInfo: any = {
  [FormTypes.t1040]: {
    title: "About 1040 income",
    subTitle: [
      `Form 1040 is the very first form of your Federal tax return; it
    summarizes your income, deductions, credits and tax liability. We
    only need you to upload the first page of this two-page form. `,
    ],
    sampleFormDescription: "Here is a sample of the 1040 form.",
    sampleFile: "2025/1040.pdf",
  },
  [FormTypes.w2]: {
    title: "About W-2 income",
    subTitle: [
      `A W-2 reports wage income from your employer and the amount of federal, state, 
      and local income tax that was withheld from those wages. You will need to 
      upload W-2s from all of your employers.`,
      `If you have more than one W-2 from the same employer, check to see if all 
      of the copies are the same. If they are, you only need to upload one copy. 
      If some of the copies report different amounts in boxes 18, 19 or 20, that 
      means local tax has been withheld for several cities. In this case, upload all 
      pages of the W-2 as a single file.`,
    ],
    sampleFormDescription: "Here is a sample of the W-2 form.",
    sampleFile: "2025/W2.pdf",
  },
  [FormTypes.schedule1]: {
    title: "About Schedule 1 income",
    subTitle: [
      `If you have income listed on line 8 of your Federal Form 1040, you will have filed a Schedule 1 with your
      Federal return. Schedule 1 is used to report income from miscellaneous sources, like alimony,
      unemployment, self-employment, and gambling. Not all of this kind of income is taxable to the City;
      when you upload your Schedule 1, LIME will figure that out for you. `,
    ],
    sampleFormDescription: "Here is a sample of the Schedule 1 form.",
    sampleFile: "2025/SCH1.pdf",
  },
  [FormTypes.scheduleC]: {
    title: "About Schedule C income",
    subTitle: [
      `Schedule C is used to report net profit or loss from business activities for people who have self-
      employment income. `,
    ],
    sampleFormDescription: "Here is a sample of the Schedule C form.",
    sampleFile: "2025/SCHC.pdf",
  },
};
